export default "__VITE_ASSET__DZ8c6vIt__"